import React, { useState } from 'react';
import WpAPI from '../../WpApi';
import { HELP_OPTIONS, APP_DOMAIN } from '../../constants/constants';
import Cookies from 'js-cookie';
import SignUpPopup from '../user/SignUpPopup';
const HelpOptions = (props) => {
    const [showLoginPopUp, setShowLoginPopUp] = useState(false);
    const [openDD, setOpenDD] = useState(false);
    const handleClickedOption = (value) => {
        localStorage.setItem('clickAction', 'help');
        let loggedIn = WpAPI.isLoggedIn();
        if (loggedIn) {
            props.setOption(value);
        } else {
            localStorage.setItem('help_subject', value);
            if (location.href != (APP_DOMAIN + '/signup/')) {
                Cookies.set('redirect_to', location.href);
            } else {
                Cookies.set('redirect_to', '/');
            }
            //setTimeout(() => { location.href = `${APP_DOMAIN}/signup/` }, 10);
            setTimeout(() => { setShowLoginPopUp(true) }, 10);
        }
    }
    return (
        <>
        <div className={`helpbox helpbox1`}>
            <label className="subject-label">Subject</label>
            <div className="option-dd" data-acsb-navigable="true" >
                <div className="dd" onClick={() => {
                    setOpenDD(!openDD);
                }}>
                    <span></span><i className="icon-right-arrow"></i>
                </div>
            </div>
            {openDD ? <div className="helpbox1-details">
                <ul>
                    {HELP_OPTIONS.map((option) => {
                        return (
                            <li onClick={() => handleClickedOption(option.name)}
                                key={option.id}
                                data-acsb-navigable="true">{option.name}</li>
                        )
                    })}
                </ul>
            </div> : ''}
        </div>
        {showLoginPopUp ? <SignUpPopup setShowLoginPopUp={ setShowLoginPopUp} /> : ''}
        </>
    );
}

export default HelpOptions;